import TranslatesRun from './translates.run';
import HttpConfiguratorRun from './http.run';
import NotificationRun from './notification.run';

import { loginRequired } from './loginRequired.run.js'

const BootstrapModule = angular.module('bootstrap', [])
  .run(TranslatesRun)
  .run(HttpConfiguratorRun)
  .run(NotificationRun)
  .run(loginRequired);

export default BootstrapModule;


/** WEBPACK FOOTER **
 ** ./frontend/bootstrap/bootstrap.js
 **/